<template>
  <div>
  <v-toolbar flat color="white">
    <v-toolbar-title>Alumnos</v-toolbar-title>
    <v-divider
      class="mx-2"
      inset
      vertical
    ></v-divider>
    <v-toolbar-title>Colegio: </v-toolbar-title>
    &nbsp;
    <v-autocomplete
      :loading="loading"
      :items="colegios"
      v-model="colegioFiltro"
      hide-no-data
      hide-details
      label=""
    ></v-autocomplete>
    <v-spacer></v-spacer>
      <v-text-field
        v-model="buscar"
        label="Buscar"
        single-line
        hide-details
        @change="actualizar()"
      ></v-text-field>
      <v-btn text icon @click="actualizar()">
        <v-icon>search</v-icon>
      </v-btn>
    <v-btn color="primary" dark class="mb-2" v-on:click="nuevoRegistro()">Inscribir alumno</v-btn>
    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Alumno independiente</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-flex xs12>
              <v-form ref="form" action="/" v-model="validarInscripcion" lazy-validation>
                <v-text-field label="Colegio" name="colegio_insc" id="colegio_insc" v-model="registro.colegio" :rules="requeridoRegla" v-bind:readonly="disabledRegistro" v-on:keyup="registro.colegio = registro.colegio.toUpperCase();"/>
                <v-select label="Tipo de colegio" name="tipo_colegio" id="tipo_colegio" :items="tiposColegio" v-model="registro.tipoColegio" v-bind:readonly="disabledRegistro" />
                <v-text-field label="Apellido Paterno" name="apellido_paterno" id="apellido_paterno" v-model="registro.apellidoPaterno" :rules="requeridoRegla" v-bind:readonly="disabledRegistro" v-on:keyup="registro.apellidoPaterno = registro.apellidoPaterno.toUpperCase();"/>
                <v-text-field label="Apellido materno" name="apellido_materno" id="apellido_materno" v-model="registro.apellidoMaterno" :rules="requeridoRegla" v-bind:readonly="disabledRegistro" v-on:keyup="registro.apellidoMaterno = registro.apellidoMaterno.toUpperCase();"/>
                <v-text-field label="Nombres" name="nombres" id="nombres" v-model="registro.nombres" :rules="requeridoRegla" v-bind:readonly="disabledRegistro" v-on:keyup="registro.nombres = registro.nombres.toUpperCase();"/>
                <v-text-field label="DNI" name="dni" id="dni" v-model="registro.dni" mask="########" :rules="dniRegla" v-bind:readonly="disabledRegistro"/>
                <v-text-field label="Teléfono" name="telefono" id="telefono" v-model="registro.telefono" mask="#########" :rules="requeridoRegla" v-bind:readonly="disabledRegistro"/>
                <v-text-field label="Correo electrónico" name="correo" id="correo" v-model="registro.correo" v-on:keyup="registro.correo = registro.correo.toUpperCase();" v-bind:readonly="disabledRegistro"/>
                <v-select label="Grado" name="grado" id="grado" :items="grados" v-model="registro.grado" item-text="nombre" item-value="id" :rules="requeridoRegla" required v-bind:readonly="disabledRegistro"/>
                <v-select label="Departamento" name="departamento" id="departamento" v-model="registro.departamento" :items="departamentos" item-text="nombre" item-value="id" :rules="requeridoRegla" return-object required v-bind:readonly="disabledRegistro"/>
                <v-select label="Provincia" name="provincia" id="provincia" v-model="registro.provincia" :items="provincias" item-text="nombre" item-value="id" :rules="requeridoRegla" required return-object v-bind:readonly="disabledRegistro"/>
                <v-select label="Distrito" name="distrito" id="distrito" v-model="registro.distrito" :items="distritos" item-text="nombre" item-value="id" :rules="requeridoRegla" required return-object v-bind:readonly="disabledRegistro"/>
                <v-select label="Sede" name="sede" id="sede" v-model="registro.sede" :items="sedes" item-text="nombre" item-value="id" :rules="requeridoRegla" v-bind:readonly="disabledRegistro"/>
                <v-select v-if="registro.inscripcion !== ''" label="Tipo de inscripción" name="inscripcion" id="inscripcion" :items="tiposInscripcion" v-model="registro.inscripcion" v-bind:readonly="disabledRegistro"/>
                <v-text-field label="Recibo" v-model="registro.recibo"></v-text-field>
                <v-text-field label="Monto" v-model="registro.monto" v-money></v-text-field>
                <v-text-field label="Código" name="codigo" mask="########" id="codigo" v-model="registro.codigo" v-bind:readonly="disabledRegistro"/>
                <v-text-field label="Clave" name="clave" id="clave" v-model="registro.clave" v-bind:readonly="disabledRegistro"/>
                <span v-if="registro.usuario !== '' && registro.usuario !== null">Registrado por {{registro.usuario}}</span>
              </v-form>
            </v-flex>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click.native="eliminarRegistro" v-if="disabledRegistro && usuarioApp.toUpperCase() === 'ADMINSAN' && !eliminar">Eliminar</v-btn>
          <v-btn color="error" @click.native="eliminarRegistro" v-if="eliminar">Confirmar eliminación</v-btn>
          <v-btn color="primary" v-on:click="nuevoRegistro()" v-if="disabledRegistro">Nuevo</v-btn>
          <v-btn color="primary" v-on:click="disabledRegistro=false" v-if="disabledRegistro">Editar</v-btn>
          <v-btn color="primary" @click.native="cerrar">Cerrar</v-btn>
          <v-btn color="primary" @click.native="guardar(1)" v-if="!disabledRegistro">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogMover" max-width="400px">
      <v-card>
        <v-card-title>
          <span class="headline">Mover alumno</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-flex xs12>
              <v-form ref="form" action="/">
                <v-text-field label="Alumno" name="alumno" id="alumno" v-model="registro2.codigo" readonly="readonly"/>
                Escoger colegio:
                <v-autocomplete
                  label="Nuevo colegio"
                  :loading="loading"
                  :items="colegios"
                  v-model="registro2.nuevoColegio"
                  hide-no-data
                  hide-details
                ></v-autocomplete>
              </v-form>
            </v-flex>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click.native="cerrarCambiarColegio">Cerrar</v-btn>
          <v-btn color="primary" @click.native="guardarCambiarColegio">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogPago" max-width="400px">
      <v-card>
        <v-card-title>
          <span class="headline">Mover alumno</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-flex xs12>
              <v-form ref="form" action="/">
                <v-text-field label="Alumno" name="alumno3" id="alumno3" v-model="registro3.codigoAlumno" v-if="registro3.codigoAlumno !== ''" readonly="readonly"/>
                <v-text-field label="Colegio" name="colegio" id="colegio" v-model="registro3.codigoColegio" v-if="registro3.codigoColegio !== ''" readonly="readonly"/>
                <v-text-field label="Número de operación" v-model="registro3.operacion" :rules="operacionRegla" mask="########"></v-text-field>
                <v-text-field label="Monto" v-model="registro3.monto" :rules="requeridoRegla" v-money></v-text-field>
                <v-btn color="primary" @click="subirVoucher()">Adjuntar voucher</v-btn>
      					<input
      						type="file"
      						style="display: none"
      						ref="image"
      						accept="image/*"
      						@change="onSubirVoucher"
      					>
                <img style="max-width: 100%" :src="mostrarVoucher(voucherURL)"/>
              </v-form>
            </v-flex>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click.native="cerrarInformarPago()">Cerrar</v-btn>
          <v-btn color="primary" @click.native="registrarPago()">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-toolbar>
  <v-data-table
    :headers="headers"
    :items="datos.data"
    :pagination.sync="pagination"
    :total-items="totalRegistros"
    :loading="loading"
    rows-per-page-text="Filas por página"
  >
    <template slot="headers" slot-scope="props">
      <tr>
        <th>
          <v-checkbox
            v-model="seleccionarTodo"
            primary
            hide-details
            @click.stop="toggleAll"
          ></v-checkbox>
        </th>
        <th
          v-for="header in props.headers"
          :key="header.text"
          :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
          @click="changeSort(header.value)"
        >
          <v-icon small>arrow_upward</v-icon>
          {{ header.text }}
        </th>
      </tr>
    </template>
    <template slot="items" slot-scope="props">
      <td :class="{filaAsesor: props.item.fila[14] === 'A'}"><v-checkbox v-model="props.item.fila[19]"></v-checkbox></td>
      <td :class="{filaAsesor: props.item.fila[14] === 'A'}">{{ props.item.fila[18] }}</td>
      <td :class="{filaAsesor: props.item.fila[14] === 'A'}">{{ props.item.fila[15] }}</td>
      <td :class="{filaAsesor: props.item.fila[14] === 'A'}">{{ props.item.fila[1] }}</td>
      <td :class="{filaAsesor: props.item.fila[14] === 'A'}">{{ props.item.fila[2] }}</td>
      <td :class="{filaAsesor: props.item.fila[14] === 'A'}">{{ props.item.fila[3] }}</td>
      <td :class="{filaAsesor: props.item.fila[14] === 'A'}">{{ props.item.fila[4] }}</td>
      <td :class="{filaAsesor: props.item.fila[14] === 'A'}">{{ props.item.fila[5] }}</td>
      <td :class="{filaAsesor: props.item.fila[14] === 'A'}">{{ props.item.fila[6] }}</td>
      <td :class="{filaAsesor: props.item.fila[14] === 'A'}">{{ props.item.fila[8] }}</td>
      <td :class="{filaAsesor: props.item.fila[14] === 'A'}">{{ props.item.fila[9] }}</td>
      <td :class="{filaAsesor: props.item.fila[14] === 'A'}">{{ props.item.fila[17] }}</td>
      <td :class="{filaAsesor: props.item.fila[14] === 'A'}" align="center">
        <v-tooltip bottom v-if="props.item.fila[0] !== 0">
          <v-icon
            slot="activator"
            @click="verRegistro(props.item)"
          >open_in_browser</v-icon>
          <span>Ver</span>
        </v-tooltip>
      </td>
      <td :class="{filaAsesor: props.item.fila[14] === 'A'}" align="center">
        <v-menu bottom left>
          <v-btn
            slot="activator"
            icon
          >
            <v-icon>more_vert</v-icon>
          </v-btn>
          <v-list>
            <v-list-tile @click="informarPago(props.item)">
              <v-list-tile-title>Informar pago</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="imprimirCredencial(props.item)">
              <v-list-tile-title>Imprimir credencial</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="cambiarColegio(props.item)">
              <v-list-tile-title>Cambiar colegio</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </td>
    </template>
    <template slot="no-data">
      <v-btn color="primary" @click="initialize">Reset</v-btn>
    </template>
  </v-data-table>
  <v-btn color="primary" dark v-on:click="imprimirCredencial('')">Credenciales</v-btn>
  <input
    type="file"
  	ref="excelFile"
  	accept="xlsx/*"
  	@change="onSubirExcel"
	>
  <v-btn color="primary" @click="registrarExcel()" v-bind:disabled="disabledExcel">Subir excel</v-btn>
  <v-btn color="error" dark @click.native="eliminarRegistrosConfirmar(1)" v-if="!eliminarRegistrosCheck">Eliminar registros</v-btn>
  <v-btn color="primary" dark @click.native="eliminarRegistrosConfirmar(0)" v-if="eliminarRegistrosCheck">Cancelar eliminación</v-btn>
  <v-btn color="error" dark @click.native="eliminarRegistros()" v-if="eliminarRegistrosCheck">Confirmar eliminación</v-btn>
</div>
</template>

<script>
import mixin from '../mixins.js'
import ubicacion from '../ubicacion.js'
export default {
  mixins: [mixin, ubicacion],
  props: ['login', 'tipoUsuario', 'usuarioApp'],
  data: () => ({
    dialog: false,
    dialogMover: false,
    dialogPago: false,
    disabledRegistro: false,
    disabledExcel: false,
    validarInscripcion: true,
    eliminar: false,
    eliminarRegistrosCheck: false,
    totalRegistros: 0,
    loading: false,
    pagination: {},
    menu: false,
    cierreFecha: null,
    colegioFiltro: 'LIBRE',
    colegios: [],
    tiposColegio: ['ESTATAL', 'PRIVADO'],
    tiposInscripcion: ['VIRTUAL', 'PRESENCIAL'],
    buscar: '',
    grados: [
      {id: '3A', nombre: 'INICIAL 3 AÑOS'},
      {id: '4A', nombre: 'INICIAL 4 AÑOS'},
      {id: '5A', nombre: 'INICIAL 5 AÑOS'},
      {id: '1P', nombre: '1º PRIMARIA'},
      {id: '2P', nombre: '2º PRIMARIA'},
      {id: '3P', nombre: '3º PRIMARIA'},
      {id: '4P', nombre: '4º PRIMARIA'},
      {id: '5P', nombre: '5º PRIMARIA'},
      {id: '6P', nombre: '6º PRIMARIA'},
      {id: '1S', nombre: '1º SECUNDARIA'},
      {id: '2S', nombre: '2º SECUNDARIA'},
      {id: '3S', nombre: '3º SECUNDARIA'},
      {id: '4S', nombre: '4º SECUNDARIA'},
      {id: '5S', nombre: '5º SECUNDARIA'}
    ],
    sedes: [
      {id: '1', nombre: 'PUNO'},
      {id: '2', nombre: 'JULIACA'},
      {id: '3', nombre: 'ILAVE'}
    ],
    selected: [],
    seleccionarTodo: true,
    headers: [
      { text: '#', value: 0, sortable: false },
      { text: 'Código', value: 1 },
      { text: 'Apellido paterno', value: 2 },
      { text: 'Apellido materno', value: 3 },
      { text: 'Nombres', value: 4 },
      { text: 'DNI', value: 5 },
      { text: 'Teléfono', value: 6 },
      { text: 'Correo', value: 7 },
      { text: 'Colegio', value: 8 },
      { text: 'Grado', value: 9 },
      { text: 'Pago', value: '', sortable: false },
      { text: 'Ver', align: 'center', value: '', sortable: false },
      { text: 'Opciones', align: 'center', value: '', sortable: false }
    ],
    datos: [],
    registro: {
      colegio: '',
      tipoColegio: '',
      apellidoPaterno: '',
      apellidoMaterno: '',
      nombres: '',
      dni: '',
      telefono: '',
      correo: '',
      grado: '',
      departamento: {id: '', nombre: ''},
      provincia: {id: '', nombre: ''},
      distrito: {id: '', nombre: ''},
      sede: ''
    },
    registro2: {
      codigo: '',
      nuevoColegio: ''
    },
    registro3: {
      codigoAlumno: '',
      codigoColegio: '',
      operacion: '',
      monto: '',
      voucher: ''
    },
    voucherURL: '',
    voucherArchivo: '',
    excel: ''
  }),
  computed: {
    provincias () {
      return this.listaProvincias[this.registro.departamento.id]
    },
    distritos () {
      return this.listaDistritos[this.registro.provincia.id]
    }
  },
  watch: {
    dialog (val) {
      val || this.cerrar()
    },
    'registro.cierreFecha' (val) {
      this.cierreFecha = this.formatoFecha(this.registro.cierreFecha)
    },
    pagination: {
      handler () {
        if (this.loading === false) {
          let descendente = 0
          if (this.pagination.descending) {
            descendente = 1
          }
          this.apiListaRegistros(this.pagination.sortBy, descendente, this.pagination.page)
        }
      },
      deep: true
    },
    'colegioFiltro' (val) {
      let descendente = 0
      if (this.pagination.descending) {
        descendente = 1
      }
      this.apiListaRegistros(this.pagination.sortBy, descendente, this.pagination.page)
    }
  },
  created () {
    this.initialize()
    if (this.login === false) {
      this.$router.push('/Ingresar')
    }
    this.pagination.rowsPerPage = 10
  },
  methods: {
    initialize () {
      this.datos = {}
    },
    toggleAll () {
      if (this.seleccionarTodo) {
        for (let item in this.datos.data) {
          this.datos.data[item].fila[19] = false
        }
        this.seleccionarTodo = false
        this.$forceUpdate()
      } else {
        for (let item in this.datos.data) {
          this.datos.data[item].fila[19] = true
        }
        this.seleccionarTodo = true
        this.$forceUpdate()
      }
    },
    changeSort (column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    },
    apiListaRegistros (idx, ord, pagina) {
      var solicitudApi = this.crearSolicitud()
      if (this.datos.pagina === undefined) {
        pagina = 0
      }
      this.loading = true
      var datos = {
        tipo: 'lista',
        nfilas: this.pagination.rowsPerPage,
        idx: idx,
        ord: ord,
        pag: pagina,
        filtro: this.colegioFiltro,
        buscar: this.buscar
      }
      solicitudApi.datos = datos
      const myRequest = new Request(`${process.env.API}inicio.php?mod=libres&accion=listar`, {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
      return fetch(
        myRequest
      )
        .then(response => response.json())
        .then(datos => {
          if (datos.l === false) {
            this.$emit('login', datos.m)
          } else {
            var contar = ((datos.d.pagina - 1) * this.pagination.rowsPerPage) + 1
            for (var indice in datos.d.data) {
              datos.d.data[indice].fila[18] = contar
              datos.d.data[indice].fila[19] = true
              contar++
            }
            this.datos = datos.d
            this.totalRegistros = this.datos.registros
            if (this.colegios.length === 0) {
              this.colegios = this.datos.colegios
            }
            this.datos.colegios = []
            if (parseInt(this.datos.pagina) !== parseInt(this.pagination.page)) {
              this.pagination.page = parseInt(this.datos.pagina)
            }
            this.loading = false
            this.$forceUpdate()
          }
        })
    },
    setTotal: function (total) {
      this.registro.comprobanteTotal = total
    },
    cambiarColegio (item) {
      this.registro2 = {
        codigo: item.fila[15],
        nuevoColegio: ''
      }
      this.dialogMover = true
    },
    cerrarCambiarColegio (item) {
      this.dialogMover = false
    },
    guardarCambiarColegio () {
      var solicitudApi = this.crearSolicitud()
      solicitudApi.datos = this.registro2
      solicitudApi.datos.filtro = this.colegioFiltro
      const myRequest = new Request(`${process.env.API}inicio.php?mod=libres&accion=guardar`, {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
      return fetch(
        myRequest
      )
        .then(response => response.json())
        .then(datos => {
          if (datos.l === false) {
            this.$emit('login', datos.m)
          } else {
            if (datos.e === 1) {
              this.cerrarCambiarColegio()
              let descendente = 0
              if (this.pagination.descending) {
                descendente = 1
              }
              this.apiListaRegistros(this.pagination.sortBy, descendente, this.pagination.page)
            } else {
              alert(datos.m)
            }
          }
        })
    },
    verRegistro (item) {
      var solicitudApi = this.crearSolicitud()
      solicitudApi.datos = {'id': item.fila[0], filtro: this.colegioFiltro}
      const myRequest = new Request(`${process.env.API}inicio.php?mod=libres&accion=ver`, {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
      return fetch(
        myRequest
      )
        .then(response => response.json())
        .then(datos => {
          if (datos.l === false) {
            this.$emit('login', datos.m)
          } else {
            this.registro = datos.d
            if (item.fila[0] !== 0) {
              this.disabledRegistro = true
            } else {
              this.disabledRegistro = false
            }
            this.dialog = true
          }
        })
    },
    editarRegistro (item) {
      var solicitudApi = this.crearSolicitud()
      solicitudApi.datos = {'id': item.fila[0]}
      const myRequest = new Request(`${process.env.API}inicio.php?mod=libres&accion=ver`, {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
      return fetch(
        myRequest
      )
        .then(response => response.json())
        .then(datos => {
          if (datos.l === false) {
            this.$emit('login', datos.m)
          } else {
            this.registro = datos.d
            this.disabledRegistro = false
            this.dialog = true
          }
        })
    },
    eliminarRegistrosConfirmar (estado) {
      if (estado === 0) {
        this.eliminarRegistrosCheck = false
      } else {
        this.eliminarRegistrosCheck = true
      }
    },
    eliminarRegistro (item) {
      if (!this.eliminar) {
        this.eliminar = true
        return
      }
      this.cerrar()
      var solicitudApi = this.crearSolicitud()
      solicitudApi.datos = {'id': this.registro.id}
      const myRequest = new Request(`${process.env.API}inicio.php?mod=libres&accion=eliminar`, {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
      return fetch(
        myRequest
      )
        .then(response => response.json())
        .then(datos => {
          if (datos.l === false) {
            this.$emit('login', datos.m)
          } else {
            this.disabledRegistro = false
            this.eliminar = false
            this.dialog = false
            let descendente = 0
            if (this.pagination.descending) {
              descendente = 1
            }
            this.apiListaRegistros(this.pagination.sortBy, descendente, this.pagination.page)
          }
        })
    },
    eliminarRegistros () {
      var solicitudApi = this.crearSolicitud()
      solicitudApi.datos = {datos: this.datos.data}
      const myRequest = new Request(`${process.env.API}inicio.php?mod=libres&accion=eliminarRegistros`, {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
      return fetch(
        myRequest
      )
        .then(response => response.json())
        .then(datos => {
          if (datos.l === false) {
            this.$emit('login', datos.m)
          } else {
            let descendente = 0
            if (this.pagination.descending) {
              descendente = 1
            }
            this.eliminarRegistrosCheck = false
            this.apiListaRegistros(this.pagination.sortBy, descendente, this.pagination.page)
          }
        })
    },
    nuevoRegistro () {
      this.verRegistro({fila: [0]})
    },
    cerrar () {
      this.eliminar = false
      this.dialog = false
      setTimeout(() => {
      }, 300)
    },
    guardar (mostrar) {
      /* if (!this.$refs.form.validate()) {
        return
      } */
      if (this.registro.recibo === '' && this.registro.monto !== '0.00') {
        alert('Debe colocar el número de recibo')
        return
      }
      if (this.registro.recibo !== '' && this.registro.monto === '0.00') {
        alert('El monto no puede ser 0')
        return
      }
      this.cerrar()
      var solicitudApi = this.crearSolicitud()
      solicitudApi.datos = this.registro
      solicitudApi.datos.filtro = this.colegioFiltro
      const myRequest = new Request(`${process.env.API}inicio.php?mod=libres&accion=guardar`, {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
      return fetch(
        myRequest
      )
        .then(response => response.json())
        .then(datos => {
          if (datos.l === false) {
            this.$emit('login', datos.m)
          } else {
            if (datos.e === 1) {
              if (mostrar === 1) {
                this.verRegistro({fila: [datos.d.id]})
              }
              let descendente = 0
              if (this.pagination.descending) {
                descendente = 1
              }
              this.apiListaRegistros(this.pagination.sortBy, descendente, this.pagination.page)
            } else {
              alert(datos.m)
            }
          }
        })
    },
    imprimirCredencial (item) {
      // this.$router.push('/Credenciales/' + item.fila[0])
      var solicitudApi = this.crearSolicitud()
      if (item === '') {
        solicitudApi.datos = {datos: this.datos.data}
      } else {
        solicitudApi.datos = {datos: [item]}
      }
      const myRequest = new Request(`${process.env.API}credencial.php`, {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
      return fetch(
        myRequest
      )
        .then(response => response.blob())
        .then(fileBlob => {
          var newBlob = new Blob([fileBlob], {type: 'application/pdf'})
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(newBlob)
            return
          }
          const data = window.URL.createObjectURL(newBlob)
          var link = document.createElement('a')
          link.href = data
          link.target = '_blank'
          link.click()
        })
    },
    informarPago (item) {
      // this.$router.push('/Pago/' + item.fila[0])
      if (this.colegioFiltro !== 'LIBRE') {
        this.registro3 = {
          codigoAlumno: '',
          codigoColegio: this.colegioFiltro,
          numero: '',
          monto: '',
          voucher: ''
        }
      } else {
        this.registro3 = {
          codigoAlumno: item.fila[15],
          codigoColegio: '',
          numero: '',
          monto: '',
          voucher: ''
        }
      }
      this.dialogPago = true
    },
    cerrarInformarPago (item) {
      this.dialogPago = false
    },
    registrarPago () {
      var solicitudApi = this.crearSolicitud()
      if (this.registro3.operacion === undefined || this.registro3.monto === undefined || this.registro3.operacion === '' || this.registro3.monto === '') {
        alert('Debe llenar todos los campos')
      } else if (this.registro3.monto === '0.00') {
        alert('Monto no puede ser 0')
      } else {
        solicitudApi.datos = this.registro3
        const myRequest = new Request(`${process.env.API}inicio.php?mod=pago&accion=guardar`, {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
        return fetch(
          myRequest
        )
          .then(response => response.json())
          .then(datos => {
            if (datos.l === false) {
              this.$emit('login', datos.m)
            } else {
              if (datos.e === 1) {
                let descendente = 0
                if (this.pagination.descending) {
                  descendente = 1
                }
                this.registro3 = {}
                this.voucherURL = ''
                this.apiListaRegistros(this.pagination.sortBy, descendente, this.pagination.page)
                this.cerrarInformarPago()
              } else {
                alert(datos.m)
              }
            }
          })
      }
    },
    subirVoucher () {
      this.$refs.image.click()
    },
    registrarVoucher (url, archivo) {
      this.voucherURL = url
      this.registro3.voucher = encodeURIComponent(url)
      this.voucherArchivo = archivo
    },
    mostrarVoucher (archivo) {
      if (archivo !== null) {
        return decodeURIComponent(archivo)
      }
      return ''
    },
    onSubirVoucher (e) {
      const files = e.target.files
      if (files[0] !== undefined) {
        if (files[0].name.lastIndexOf('.') <= 0) {
          return
        }
        const fr = new FileReader()
        fr.readAsDataURL(files[0])
        fr.addEventListener('load', () => {
          var img = document.createElement('img')
          img.src = fr.result
          img.addEventListener('load', () => {
            var canvas = document.createElement('canvas')
            var ctx = canvas.getContext('2d')
            ctx.drawImage(img, 0, 0)

            var MAX_WIDTH = 400
            var MAX_HEIGHT = 400
            var width = img.width
            var height = img.height

            if (width > height) {
              if (width > MAX_WIDTH) {
                height *= MAX_WIDTH / width
                width = MAX_WIDTH
              }
            } else {
              if (height > MAX_HEIGHT) {
                width *= MAX_HEIGHT / height
                height = MAX_HEIGHT
              }
            }
            canvas.width = width
            canvas.height = height
            ctx = canvas.getContext('2d')
            ctx.drawImage(img, 0, 0, width, height)

            this.registrarVoucher(canvas.toDataURL(files[0].type), files[0])
          })
        })
      } else {
        this.voucherArchivo = ''
        this.voucherURL = ''
      }
    },
    setExcel (data) {
      this.excel = data
    },
    onSubirExcel () {
      const files = this.$refs.excelFile.files
      if (files[0] !== undefined) {
        if (files[0].name.lastIndexOf('.') <= 0) {
          return
        }
        const fr = new FileReader()
        // fr.readAsDataURL(files[0])
        fr.readAsBinaryString(files[0])
        fr.onload = () => {
          this.setExcel(fr.result)
        }
        fr.onerror = (error) => {
          console.log('Error ', error)
        }
      }
    },
    validarRegistro () {
      if (this.registro.colegio === '') {
        alert('Debe rellenar el Colegio')
        return false
      }
      if (this.registro.apellidoPaterno === '') {
        alert('Debe rellenar el apellido paterno')
        return false
      }
      if (this.registro.apellidoMaterno === '') {
        alert('Debe rellenar el apellido materno')
        return false
      }
      if (this.registro.nombres === '') {
        alert('Debe rellenar el nombre')
        return false
      }
      if (this.registro.dni === '' || this.registro.dni.length !== 8) {
        alert('DNI incorrecto: ' + this.registro.dni)
        return false
      }
      if (this.registro.telefono === '') {
        alert('Debe rellenar el teléfono')
        return false
      }
      return true
    },
    async registrarExcel () {
      this.disabledExcel = true
      var XLSX = require('xlsx')
      var libro = XLSX.read(this.excel, {
        type: 'binary'
      })
      var primeraHoja = libro.SheetNames[0]
      var excelFilas = XLSX.utils.sheet_to_json(libro.Sheets[primeraHoja])
      for (var excelFila in excelFilas) {
        if (excelFilas[excelFila]['Sede'] === undefined) {
          excelFilas[excelFila]['Sede'] = localStorage.getItem('local')
        }
        if (excelFilas[excelFila]['Colegio'] === undefined || excelFilas[excelFila]['Tipo de colegio'] === undefined || excelFilas[excelFila]['Apellido paterno'] === undefined || excelFilas[excelFila]['Apellido materno'] === undefined || excelFilas[excelFila]['Nombres'] === undefined || excelFilas[excelFila]['DNI'] === undefined || excelFilas[excelFila]['Teléfono'] === undefined || excelFilas[excelFila]['Correo'] === undefined || excelFilas[excelFila]['Grado'] === undefined || excelFilas[excelFila]['Departamento'] === undefined || excelFilas[excelFila]['Provincia'] === undefined || excelFilas[excelFila]['Distrito'] === undefined || excelFilas[excelFila]['Recibo'] === undefined || excelFilas[excelFila]['Monto'] === undefined || excelFilas[excelFila]['Sede'] === undefined) {
          alert('Excel no reconocido')
          return
        }
        if (excelFilas[excelFila]['Tipo de colegio'] !== 'E' && excelFilas[excelFila]['Tipo de colegio'] !== 'P') {
          alert('Tipo de colegio no reconocido - Fila ' + excelFila)
          return
        }
        if (excelFilas[excelFila]['Grado'] !== '3A' && excelFilas[excelFila]['Grado'] !== '4A' && excelFilas[excelFila]['Grado'] !== '5A' && excelFilas[excelFila]['Grado'] !== '1P' && excelFilas[excelFila]['Grado'] !== '2P' && excelFilas[excelFila]['Grado'] !== '3P' && excelFilas[excelFila]['Grado'] !== '4P' && excelFilas[excelFila]['Grado'] !== '5P' && excelFilas[excelFila]['Grado'] !== '6P' && excelFilas[excelFila]['Grado'] !== '1S' && excelFilas[excelFila]['Grado'] !== '2S' && excelFilas[excelFila]['Grado'] !== '3S' && excelFilas[excelFila]['Grado'] !== '4S' && excelFilas[excelFila]['Grado'] !== '5S') {
          alert('Grado no reconocido - Fila ' + excelFila)
          return
        }
        if (typeof excelFilas[excelFila]['DNI'] !== 'string') {
          excelFilas[excelFila]['DNI'] = excelFilas[excelFila]['DNI'].toString()
        }
        this.registro = {
          'colegio': excelFilas[excelFila]['Colegio'],
          'tipoColegio': excelFilas[excelFila]['Tipo de colegio'],
          'inscripcion': 'PRESENCIAL',
          'id': '0',
          'apellidoPaterno': excelFilas[excelFila]['Apellido paterno'],
          'apellidoMaterno': excelFilas[excelFila]['Apellido materno'],
          'nombres': excelFilas[excelFila]['Nombres'],
          'dni': excelFilas[excelFila]['DNI'],
          'telefono': excelFilas[excelFila]['Teléfono'],
          'correo': excelFilas[excelFila]['Correo'],
          'grado': excelFilas[excelFila]['Grado'],
          'departamento': {},
          'provincia': {},
          'distrito': {},
          'sede': excelFilas[excelFila]['Sede'],
          'recibo': excelFilas[excelFila]['Recibo'],
          'monto': excelFilas[excelFila]['Monto'] + '.00',
          'codigo': '',
          'clave': ''
        }
        // console.log(excelFilas[excelFila]['Sede'])
        var nSede = this.sedes.findIndex(i => i.nombre === excelFilas[excelFila]['Sede'].toUpperCase())
        if (nSede < 0) {
          alert('Sede no reconocida - Fila ' + excelFila)
          return
        } else {
          this.registro.sede = this.sedes[nSede].id
        }
        var nDepartamento = this.departamentos.findIndex(i => i.nombre === excelFilas[excelFila]['Departamento'].toUpperCase())
        if (nDepartamento < 0) {
          alert('Departamento no reconocido - Fila ' + excelFila)
          return
        } else {
          this.registro.departamento = this.departamentos[nDepartamento]
        }
        var nProvincia = this.listaProvincias[this.registro.departamento.id].findIndex(i => i.nombre === excelFilas[excelFila]['Provincia'].toUpperCase())
        if (nProvincia < 0) {
          alert('Provincia no reconocida - Fila ' + excelFila)
          return
        } else {
          this.registro.provincia = this.listaProvincias[this.registro.departamento.id][nProvincia]
        }
        var nDistrito = this.listaDistritos[this.registro.provincia.id].findIndex(i => i.nombre === excelFilas[excelFila]['Distrito'].toUpperCase())
        if (nDistrito < 0) {
          alert('Distrito no reconocido - Fila ' + excelFila)
          return
        } else {
          this.registro.distrito = this.listaDistritos[this.registro.provincia.id][nDistrito]
        }
        // console.log(this.registro)
        if (!this.validarRegistro()) {
          return
        }
      }
      for (excelFila in excelFilas) {
        this.registro = {
          'colegio': excelFilas[excelFila]['Colegio'],
          'tipoColegio': excelFilas[excelFila]['Tipo de colegio'],
          'inscripcion': 'PRESENCIAL',
          'id': '0',
          'apellidoPaterno': excelFilas[excelFila]['Apellido paterno'],
          'apellidoMaterno': excelFilas[excelFila]['Apellido materno'],
          'nombres': excelFilas[excelFila]['Nombres'],
          'dni': excelFilas[excelFila]['DNI'],
          'telefono': excelFilas[excelFila]['Teléfono'],
          'correo': excelFilas[excelFila]['Correo'],
          'grado': excelFilas[excelFila]['Grado'],
          'departamento': {},
          'provincia': {},
          'distrito': {},
          'sede': excelFilas[excelFila]['Sede'],
          'recibo': excelFilas[excelFila]['Recibo'],
          'monto': excelFilas[excelFila]['Monto'] + '.00',
          'codigo': '',
          'clave': ''
        }
        nSede = this.sedes.findIndex(i => i.nombre === excelFilas[excelFila]['Sede'].toUpperCase())
        this.registro.sede = this.sedes[nSede].id
        nDepartamento = this.departamentos.findIndex(i => i.nombre === excelFilas[excelFila]['Departamento'].toUpperCase())
        this.registro.departamento = this.departamentos[nDepartamento]
        nProvincia = this.listaProvincias[this.registro.departamento.id].findIndex(i => i.nombre === excelFilas[excelFila]['Provincia'].toUpperCase())
        this.registro.provincia = this.listaProvincias[this.registro.departamento.id][nProvincia]
        nDistrito = this.listaDistritos[this.registro.provincia.id].findIndex(i => i.nombre === excelFilas[excelFila]['Distrito'].toUpperCase())
        this.registro.distrito = this.listaDistritos[this.registro.provincia.id][nDistrito]
        await this.guardar(0)
      }
      this.disabledExcel = false
    },
    actualizar () {
      let descendente = 0
      if (this.pagination.descending) {
        descendente = 1
      }
      this.apiListaRegistros(this.pagination.sortBy, descendente, this.pagination.page)
    }
  }
}
</script>

<style>
.filaAsesor {
    background: lightblue;
}
table.v-table tbody td:first-child, table.v-table tbody td:not(:first-child), table.v-table tbody th:first-child, table.v-table tbody th:not(:first-child), table.v-table thead td:first-child, table.v-table thead td:not(:first-child), table.v-table thead th:first-child, table.v-table thead th:not(:first-child) {
    padding: 0 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/Libres.vue